import {useState, useEffect, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate, useParams} from 'react-router-dom'
import Loading from '../../Loading';
import Header from './Header';
import Input from '../../component/form/Input';
import Select from '../../component/form/Select';
import Button from '../../component/form/Button';
import InputDefaultValue from '../../component/form/InputDefaultValue';
import {ToastContainer, toast} from 'react-toastify';
import {documentShow} from '../../features/dashboard/DocumentSlice'
import {archiveIndex} from '../../features/dashboard/ArchiveSlice';
import {sectionOneSearch, sectionTwoSearch, sectionThreeSearch} from '../../features/dashboard/SectionSlice';
import {fetchDocumentStatus} from '../../features/dashboard/DocumentStatusSlice'
import Broadcast from "./Broadcast";
import axios from 'axios';
import {host} from "../../function/api";
import Message from "../form/Message";
import {documentSearch} from "../../features/dashboard/DocumentRequestSlice";

function DocumentEdit() {
    const id = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [number, setNumber] = useState()
    // set fetch data from kavir state
    const tp_karbari = useRef('')
    const tp_tip = useRef('')
    const cl_name = useRef('')
    const mt_model = useRef('')
    const tp_system = useRef('')
    const mt_bodyno = useRef('')
    const mt_motorno = useRef('')
    const mt_pelakno = useRef('')
    const mt_sanadno = useRef('')
    const tp_mehvar = useRef('')
    const tp_charkh = useRef('')
    const tp_zarfiyat = useRef('')
    const tp_cylandr = useRef('')
    const tp_sookht = useRef('')
    const tp_hajm = useRef('')
    const mt_pelakserial = useRef('')
    const mt_pelakdate = useRef('')

    const [name, setName] = useState('')
    const [family, setFamily] = useState('')
    const [nationalCode, setNationalCode] = useState('')
    const [father_name, setFatherName] = useState('')
    const [idcard, setIdcard] = useState('')
    const [mobile, setMobile] = useState('')
    const [HashCode, setHashCodeNumber] = useState('')
    const [TextValidation, setTextValidation] = useState('')
    const [phone, setPhone] = useState('')
    const [address, setAddress] = useState('')
    const [postalcode, setPostalcode] = useState('')
    const [birthplace, setBirthplace] = useState('')
    const [placeofissue, setPlaceofissue] = useState('')
    const [birthdaye, setbirthdaye] = useState()
    // data set variables
    const [transferToStore, setTransferToStore] = useState('')
    const [section, setSection] = useState('')
    const [sectionId, setSectionId] = useState('')
    const [partone, setPartone] = useState('')
    const [parttwo, setParttwo] = useState('')
    const [partthree, setPartthree] = useState('')

    const [btnSms, setBtnSms] = useState('');
    const [btnConfirm, setBtnConfirm] = useState('');
    const [btnDisable, setBtnDisable] = useState('');
    const [btnSubmit, setBtnSubmit] = useState('');
    const [btnFind, setBtnFind] = useState('');
    const [boxCustomer, setBoxCustomer] = useState('');
    const [verificationCode, setVerificationCode] = useState('')
    const [customerType, setCustomerType] = useState('nationalCode')
    const [customerNumber, setCustomerNumber] = useState('')
    const [rk_buyer_mobile_validation, setRk_buyer_mobile_validation] = useState('')
    const [rk_birth_certificate, setRk_birth_certificate] = useState('')
    const [rk_national_card, setRk_national_card] = useState('')

    const [rk_policy, setRk_policy] = useState('')
    const [rk_residence_verification, setRk_residence_verification] = useState('')
    const [rk_receipt, setRk_receipt] = useState('')
    const [rk_transfer_document, setRk_transfer_document] = useState('')
    const [rk_description, setRk_description] = useState('')
    const {
        document,
        loading,
        success,
        status,
        error,
        errorName,
        errorFamily,
        errorNationalCode,
        errorNumber,
        errorNumberType,
        errorTransferToStore,
        errorDescription,
        errorStatus,
        errorMobile,
        errorPartOne,
        errorPartTwo,
        errorPartThree,
        error_mt_bodyno,
        error_mt_motorno,
        error_mt_pelakno,
        error_mt_sanadno,
        error_mt_pelakserial
    } = useSelector((state) => state.document)
    const {archives} = useSelector(state => state.archive)
    const {statuses} = useSelector(state => state.status)
    const {sections, partOne, partTwo} = useSelector(state => state.section)
    const token = localStorage.getItem('token')

    const RahpardaznetValidationNationalCode = (number) => {
        if (!/^\d{10}$/.test(number)) return false;
        const check = +number[9];
        const sum = number.split('').slice(0, 9).reduce((acc, x, i) => acc + +x * (10 - i), 0) % 11;
        return sum < 2 ? check === sum : check + sum === 11;

    }

    const documentUpdateHandler = async (event) => {
        event.preventDefault()
        if (postalcode && postalcode.length > 1 && postalcode != " ") {

            let replacePostal = postalcode.replace(" ", "");
            if (replacePostal.length != 10) {
                toast.error("کدپستی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        if (mobile && mobile.length != 0 && mobile != " ") {
            let replaceMobile = mobile.replace(" ", "");
            if (replaceMobile && replaceMobile.length != 11) {
                toast.error("شماره موبایل باید 11 رقم باشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return
            }
        }


        const data = {
            'id': id.id,
            'mt_sanadno': document.mt_sanadno,
            'name': name ? name : null,
            'family': family ? family : null,
            'nationalCode': customerNumber ? customerNumber : nationalCode,
            'father_name': father_name ? father_name : null,
            'idcard': idcard,
            'mobile': mobile,
            'phone': phone ? phone : null,
            'address': address ? address : null,
            'postalcode': postalcode,
            'birthplace': birthplace,
            'placeofissue': placeofissue,
            'birthdaye': birthdaye,
            'verificationCode': verificationCode,
            'rk_birth_certificate': rk_birth_certificate,
            'rk_national_card': rk_national_card,
            'rk_policy': rk_policy,
            'rk_residence_verification': rk_residence_verification,
            'rk_receipt': rk_receipt,
            'rk_description': rk_description,

            'validation_mobile': btnSms
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}documentRequest/update`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                toast.success("سند با موفقیت بروزرسانی شد.", {
                    position: "top-center",
                    autoClose: 1500,
                })

            }

        } catch (error) {
            if (error.response.data.error) {
                const listError = error.response.data.error;
                $.each(listError, function (index, value) {
                    if (typeof (value) == 'object') {
                        toast.error(value[0], {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    } else {
                        toast.error(value, {
                            position: "top-center",
                            autoClose: 5000,
                        })
                    }
                });
            }

        }

    }
    const customerSearchHandler = async (event) => {
        event.preventDefault()

        setBoxCustomer(' ');
        if (customerNumber.length != 11) {
            if (RahpardaznetValidationNationalCode(customerNumber) !== true) {
                toast.error("کدملی نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                return;
            }
        }

        setBtnFind('1');

        const data = {
            'type': 'nationalCode',
            'number': customerNumber
        }
        try {
            const response = await axios({
                method: 'POST',
                url: `${host}customer/find`,
                data: data,
                headers: {
                    'Accept': 'Application/json',
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })

            if (response.data.status == true) {
                setName(response.data.data.name);
                setFamily(response.data.data.family);
                setNationalCode(response.data.data.nationalCode);
                setFatherName(response.data.data.father_name);
                setIdcard(response.data.data.idcard);
                setMobile(response.data.data.mobile);
                setPhone(response.data.data.phone);
                setAddress(response.data.data.address);
                setPostalcode(response.data.data.postalcode);
                setBirthplace(response.data.data.birthplace);
                setPlaceofissue(response.data.data.placeofissue);
                setbirthdaye(response.data.data.birthdaye ? response.data.data.birthdaye : null);
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setBtnSms('3');
            } else {
                setName(' ');
                setFamily(' ');
                setNationalCode(' ');
                setFatherName(' ');
                setIdcard(' ');
                setMobile(' ');
                setPhone(' ');
                setAddress(' ');
                setPostalcode(' ');
                setBirthplace(' ');
                setPlaceofissue(' ');
                setbirthdaye(' ');
                setBoxCustomer('1');
                setBtnConfirm(' ');
                setBtnDisable(' ');
                setTextValidation(' ');
                setVerificationCode(' ');
                setBtnSms('3');
                if (customerNumber.length == 10) {
                    toast.error("کاربری با این کد ملی پیدا نشد.", {
                        position: "top-center",
                        autoClose: 1200,
                    })
                } else {
                    toast.error("پیدا نشد وبه عنوان شرکت حقوقی ثبت می شود.", {
                        position: "top-center",
                        autoClose: 1200,
                    })
                }

            }


        } catch (error) {
            setName(' ');
            setFamily(' ');
            setNationalCode(' ');
            setFatherName(' ');
            setIdcard(' ');
            setMobile(' ');
            setPhone(' ');
            setAddress(' ');
            setPostalcode(' ');
            setBirthplace(' ');
            setPlaceofissue(' ');
            setbirthdaye(' ');
            setBoxCustomer('1');
            setBtnConfirm(' ');
            setBtnDisable(' ');
            setTextValidation(' ');
            setVerificationCode(' ');

            setBtnSms('3');

            if (customerNumber.length == 10) {
                toast.error("کاربری با این کد ملی پیدا نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            } else {
                toast.error("پیدا نشد وبه عنوان شرکت حقوقی ثبت می شود.", {
                    position: "top-center",
                    autoClose: 1200,
                })
            }
        }


        setBtnFind('');

    }
    const verivicationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        const data = {
            mobile: mobile ? mobile : null
        }


        setHashCodeNumber("");

        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/verificationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.status == 200) {
                toast.success("پیامک با موفقیت ارسال شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })


                setBtnSms('3');
                setHashCodeNumber(res.data.hash);
                setBtnConfirm('1');
            } else {
                toast.error("پیامک ارسال نشد.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms('3');
            }

        } catch (error) {
            toast.error("پیامک ارسال نشد.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms('3');
        }
// dispatch(mobileVerificationCode(data))
// console.log(sms_status);

    }


    useEffect(() => {
        dispatch(documentShow(id))
        dispatch(archiveIndex(token))
        dispatch(fetchDocumentStatus(token))
    }, [id])

    useEffect(() => {
        setRk_description(document.description);
        console.log(document.customer_data);
        if (document && document.customer_data && document.customer_data != [] && typeof document.customer_data === 'object') {

                setName(document.customer_data.name ? document.customer_data.name : " ");
                setFamily(document.customer_data.family ? document.customer_data.family : " ");
                setNationalCode(document.customer_data.nationalCode ? document.customer_data.nationalCode : " ");
                setFatherName(document.customer_data.father_name ? document.customer_data.father_name : " ");
                setIdcard(document.customer_data.idcard ? document.customer_data.idcard : " ");
                setMobile(document.customer_data.mobile ? document.customer_data.mobile : " ");
                setPhone(document.customer_data.phone ? document.customer_data.phone : " ");
                setAddress(document.customer_data.address ? document.customer_data.address : " ");
                setPostalcode(document.customer_data.postalcode ? document.customer_data.postalcode : " ");
                setBirthplace(document.customer_data.birthplace ? document.customer_data.birthplace : " ");
                setPlaceofissue(document.customer_data.placeofissue ? document.customer_data.placeofissue : " ");
                setbirthdaye(document.customer_data.birthdaye ? document.customer_data.birthdaye : " ");


        }


        if (document && document.customer_data && document.customer_data != [] && typeof document.document_received === 'object') {
                setRk_birth_certificate(document.document_received.rk_birth_certificate == 'true' ? true : null);
                setRk_national_card(document.document_received.rk_national_card == 'true' ? true : null);
                setRk_policy(document.document_received.rk_policy == 'true' ? true : null);
                setRk_residence_verification(document.document_received.rk_residence_verification == 'true' ? true : null);
                setRk_receipt(document.document_received.rk_receipt == 'true' ? true : null);


        }


    }, [document])
    const transferStoreHandler = (value) => {
        setTransferToStore(value)
        const searchItem = {
            'store_id': value
        }
        dispatch(sectionOneSearch(searchItem))
    }

    const sectionOneSearchHandler = (value) => {
        setPartone(value)
        const partOneItem = {
            'section_one_id': value,
        }
        dispatch(sectionTwoSearch(partOneItem));
    }

    const sectionTwoSearchHandler = (value) => {
        setParttwo(value)
        const partTwoItem = {
            'section_two_id': value,
        }
        dispatch(sectionThreeSearch(partTwoItem));
    }

    const validationCodeHandler = async (e) => {
        e.preventDefault();
        setBtnSms('1');
        setBtnDisable("1");
        const data = {
            mobile: mobile,
            code: verificationCode,
            hash: HashCode
        }


        try {
            const res = await axios({
                method: 'POST',
                url: `${host}customer/mobile/validationCode`,
                data: data,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'xsrfHeaderName': "X-XSRF-TOKEN",
                    'withCredentials': true,
                }
            })
            if (res.data.status) {
                toast.success("اعتبار سنجی با موفقیت انجام شد.", {
                    position: "top-center",
                    autoClose: 1200,
                })
                setBtnSubmit('1');
                setTextValidation('1');
                setBtnSms('2');
                setOwnerBtnSubmit('1');
            } else {
                toast.error("کد تایید نامعتبر است.", {
                    position: "top-center",
                    autoClose: 1200,
                })

                setBtnSms('3');

                setBtnDisable("");
            }

        } catch (error) {
            toast.error("کد تایید نا معتبر است.", {
                position: "top-center",
                autoClose: 1200,
            })

            setBtnSms('3');

            setBtnDisable("");
        }


// dispatch(mobileVerificationCode(data))
// console.log(sms_status);

    }
    return (
        <>
            {loading ? <Loading/> : null}
            <Broadcast title={document.mt_sanadno ? "ویرایش سند شماره: " + document.mt_sanadno : null}/>
            {
                (typeof document === 'object') ? (
                    (Object.keys(document).length != 0 && success === true) ? (
                        <>
                            {
                                (document.section_three) ? (

                                    <div className='row rahpardaznet-cart  my-5  print-position'>
                                        <Header title='اطلاعات انبار'/>
                                        <div className='col-12 d-flex rahpardaznet-section-box'>
                                            <div
                                                className='rahpardaznet-section section-main'>{document.section_main}</div>
                                            <div
                                                className='rahpardaznet-section section-one'>{document.section_one}</div>
                                            <div
                                                className='rahpardaznet-section section-two'>{document.section_two}</div>
                                            <div
                                                className='rahpardaznet-section section-three'>{document.section_three}</div>
                                        </div>
                                    </div>
                                ) : null
                            }
                            <div className='row rahpardaznet-cart  my-5  print-position'>
                                {
                                    !document.id ? (
                                            <Header title='اطلاعات کارخانه'/>
                                        )
                                        : (
                                            <Header title='اطلاعات انبار'/>
                                        )
                                }
                                <div
                                    className='col-4 col-md-4 p-3 list-group list-group-flush d-flex flex-column  align-items-center border font'>
                                    <input type="hidden" ref={mt_sanadno} value={document.mt_sanadno}/>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        {
                                            (document.mt_pelakno != '0') ? (
                                                <div
                                                    className='d-flex flex-column justify-content-center align-items-center rahpardaznet-pelak rahpardaznet-pelak-box'>
                                                        <span
                                                            ref={mt_pelakserial}>{document.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span ref={mt_pelakno}>
                                                            {document.mt_pelakno}
                                                        </span>
                                                </div>
                                            ) : (
                                                <div className='rahpardaznet-pelakno'>
                                                        <span className="d-none"
                                                              ref={mt_pelakserial}>{document.mt_pelakserial.replace("ایران", "")}</span>
                                                    <span className="d-none" ref={mt_pelakno}>
                                                            {document.mt_pelakno}
                                                        </span>
                                                    <span className='text-danger'>بدون پلاک</span>
                                                </div>
                                            )
                                        }

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> تاریخ نصب : </label>
                                        <span ref={mt_pelakdate}>{document.mt_pelakdate}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex fs-5">
                                        <label> شماره سند : </label>
                                        <span ref={mt_sanadno}>{document.mt_sanadno}</span>
                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع کاربری : </label>
                                        <span ref={tp_karbari}>{document.tp_karbari}</span>
                                    </li>

                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> سیستم : </label>
                                        <span ref={tp_system}>{document.tp_system}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تیپ : </label>
                                        <span ref={tp_tip}>{document.tp_tip}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> رنگ : </label>
                                        <span ref={cl_name}>{document.cl_name}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> مدل : </label>
                                        <span ref={mt_model}>{document.mt_model}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره بدنه : </label>
                                        <span className="font-style" ref={mt_bodyno}>
                                                {document.mt_bodyno}
                                            </span>
                                        <button type="button" className="rahpardaznet-copy-button"
                                                data-name="شماره بدنه" data-text={document.mt_bodyno}>کپی
                                        </button>

                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> شماره انجین : </label>
                                        <span className="font-style" ref={mt_motorno}>
                                                {document.mt_motorno}
                                            </span>

                                        <button type="button" className="rahpardaznet-copy-button"
                                                data-name="شماره انجین" data-text={document.mt_motorno}>کپی
                                        </button>

                                    </li>
                                </div>
                                <div className="col-4 col-md-4 p-3 list-group list-group-flush border">
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد محور : </label>
                                        <span ref={tp_mehvar}>{document.tp_mehvar}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد چرخ : </label>
                                        <span ref={tp_charkh}>{document.tp_charkh}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> ظرفیت : </label>
                                        <span ref={tp_zarfiyat}>{document.tp_zarfiyat}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> تعداد سیلندر : </label>
                                        <span ref={tp_cylandr}>{document.tp_cylandr}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> نوع سوخت : </label>
                                        <span ref={tp_sookht}>{document.tp_sookht}</span>
                                    </li>
                                    <li className="rahpardaznet-list-group-item justify-content-start align-items-center d-flex">
                                        <label> حجم سیلندر : </label>
                                        <span ref={tp_hajm}>{document.tp_hajm}</span>
                                    </li>
                                </div>
                            </div>
                            <div className='row rahpardaznet-cart my-5 print-position'>
                                <Header title={'درخواست مشتری'}/>
                                <div className="col-12">
                                    <form className="rahpardaz-search-form-select">

                                        <select
                                            value={customerType}
                                            defaultValue={'nationalCode'}
                                            className='form-control form-select form-select-lg shadow-none d-none'
                                            onChange={(e) => setCustomerType(e.target.value)}
                                            aria-label="form-select-lg example">
                                            <option value='DEFAULT' selected disabled>یک
                                                مورد را انتخاب کنید
                                            </option>
                                            {/* <option value='mobile'>شماره موبایل</option> */}
                                            <option value='nationalCode'>شماره ملی</option>

                                        </select>


                                        <input
                                            type="text"
                                            value={customerNumber}
                                            onChange={(e) => setCustomerNumber(e.target.value)}
                                            id=""
                                            className="form-control  form-control-lg  shadow-none border-right"
                                            placeholder='کدملی مشتری را وارد نمایید.'
                                        />

                                        <button
                                            onClick={customerSearchHandler}
                                            type="submit"
                                            className="print-no rahpardaznet-search-btn">
                                            {btnFind ? (
                                                <div className="spinner-border text-light"
                                                     role="status"></div>) : "جستجوی مشتری "}
                                            {'   '}

                                        </button>

                                    </form>


                                </div>
                            </div>
                            <div className='row rahpardaznet-cart  my-5 '>
                                <Header title={'مشخصات خریدار'}/>
                                <>
                                    <form>
                                        <div className="row">
                                            <div className="col-12 col-md-6 ">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor=""
                                                           className="text-end form-label px-1 ">
                                                        نام
                                                    </label>
                                                    <input
                                                        tabIndex="3"
                                                        type="text"
                                                        value={name}
                                                        onChange={(e) => setName(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id=""
                                                        placeholder=""
                                                        autoFocus
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor=""
                                                           className="text-end form-label px-1 ">
                                                        نام خانوادگی
                                                    </label>
                                                    <input
                                                        tabIndex="4"
                                                        type="text"
                                                        value={family}
                                                        onChange={(e) => setFamily(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id=""
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="father_name"
                                                           className="text-end form-label px-1 ">
                                                        نام پدر
                                                    </label>
                                                    <input
                                                        tabIndex="5"
                                                        type="text"
                                                        value={father_name}
                                                        onChange={(e) => setFatherName(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="father_name"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label
                                                        htmlhtmlFor="nationalCode"
                                                        className="text-end form-label px-1 ">
                                                        شماره/شناسه ملی
                                                    </label>
                                                    <input
                                                        disabled
                                                        tabIndex="6"
                                                        type="text"
                                                        value={customerNumber}
                                                        // onChange={(e) => setNationalCode(e.target.value)}
                                                        className="form-control shadow-none text-left"
                                                        id="nationalCode"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className='row m-3 d-flex flex-row justify-content-between rahpardaznet-form-controll'>
                                                    <label htmlhtmlFor="mobile"
                                                           className="text-end form-label px-1 d-flex justify-content-between">
                                                        تلفن همراه
                                                    </label>

                                                    <div className='background-transparent'>
                                                        <input className="form-check-input" type="checkbox" value=""
                                                               id="rahpardaznet-buyer-mobile-validation"
                                                               onChange={(e) => setRk_buyer_mobile_validation(e.target.checked)}/>
                                                        <label className="form-check-label"
                                                               htmlhtmlFor="rahpardaznet-receipt">اعتبار سنجی شماره
                                                            موبایل خریدار</label>
                                                    </div>
                                                    {
                                                        (rk_buyer_mobile_validation == '1') ? (
                                                            <>
                                                                <input
                                                                    type="hidden"
                                                                    disabled
                                                                    value={HashCode ? HashCode : null}
                                                                    onChange={(e) => setHashCodeNumber(e.target.value)}
                                                                    className="form-control shadow-none text-left"
                                                                    id="HashCode"
                                                                    placeholder=""
                                                                />
                                                                <div className='rahpardaznet-form-mobile'>
                                                                    <input
                                                                        disabled={btnDisable == '1' ? 'disabled' : false}
                                                                        tabIndex="7"
                                                                        type="text"
                                                                        value={mobile}
                                                                        onChange={(e) => setMobile(e.target.value)}
                                                                        className=""
                                                                        id="mobile"
                                                                        placeholder="شماره تلفن"
                                                                    />
                                                                    <input
                                                                        disabled={btnDisable == '1' ? 'disabled' : false}
                                                                        tabIndex="8"
                                                                        type="text"
                                                                        value={verificationCode ? verificationCode : null}
                                                                        onChange={(e) => setVerificationCode(e.target.value)}

                                                                        id="verificationCode"
                                                                        placeholder="کد تایید"
                                                                    />

                                                                    {
                                                                        (btnConfirm != '1') ? (
                                                                            <button
                                                                                tabIndex='9'
                                                                                onClick={verivicationCodeHandler}
                                                                                type="submit"
                                                                                className="print-no">
                                                                                {btnSms == '1' ? (<div
                                                                                    className="spinner-border text-light"
                                                                                    role="status"></div>) : "ارسال"}


                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                disabled={btnDisable == '1' ? 'disabled' : false}
                                                                                tabIndex='9'
                                                                                onClick={validationCodeHandler}
                                                                                type="submit"
                                                                                className="print-no rahpardaznet-validation">
                                                                                {
                                                                                    btnSms == '1' && (<div
                                                                                        className="spinner-border text-light"
                                                                                        role="status"></div>)
                                                                                    || btnSms == '2' && "تایید شده"
                                                                                    || "تایید"
                                                                                }


                                                                            </button>
                                                                        )

                                                                    }


                                                                </div>

                                                                {
                                                                    (TextValidation == '1') ? (
                                                                        <span
                                                                            className="help-block d-inline-block mt-2 mr-0 pr-0">
                                                                        <small className='text-success'>شماره موبایل خریدار با موفقیت اعتبار سنجی شد.</small>
                                                                    </span>
                                                                    ) : ''
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='rahpardaznet-form-controll'>
                                                                    <input
                                                                        tabIndex="7"
                                                                        type="text"
                                                                        value={mobile}
                                                                        onChange={(e) => setMobile(e.target.value)}
                                                                        className="form-control shadow-none text-left"
                                                                        id="mobile"
                                                                        placeholder="شماره تلفن"
                                                                    />

                                                                </div>
                                                            </>
                                                        )
                                                    }


                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="phone"
                                                           className="text-end form-label px-1 ">
                                                        تلفن
                                                    </label>
                                                    <input
                                                        tabIndex="10"
                                                        type="text"
                                                        value={phone}
                                                        onChange={(e) => setPhone(e.target.value)}
                                                        className="form-control shadow-none text-left"
                                                        id="phone"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="birthplace"
                                                           className="text-end form-label px-1 ">
                                                        محل تولد
                                                    </label>
                                                    <input
                                                        tabIndex="11"
                                                        type="text"
                                                        value={birthplace}
                                                        onChange={(e) => setBirthplace(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="birthplace"
                                                        placeholder=""
                                                    />


                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="birthdaye"
                                                           className="text-end form-label px-1 ">
                                                        تاریخ تولد
                                                    </label>


                                                    <input
                                                        tabIndex="12"
                                                        type="text"
                                                        value={birthdaye}
                                                        onChange={(e) => setbirthdaye(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="birthdaye"
                                                        placeholder=""
                                                    />
                                                    <div>

                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="idcard"
                                                           className="text-end form-label px-1 ">
                                                        شماره شناسنامه / ثبت
                                                    </label>
                                                    <input
                                                        tabIndex="13"
                                                        type="number"
                                                        value={idcard}
                                                        onChange={(e) => setIdcard(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="idcard"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="father_name"
                                                           className="text-end form-label px-1 ">
                                                        محل صدور
                                                    </label>
                                                    <input
                                                        tabIndex="14"
                                                        type="text"
                                                        value={placeofissue}
                                                        onChange={(e) => setPlaceofissue(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="father_name"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="postalcode"
                                                           className="text-end form-label px-1 ">
                                                        کد پستی
                                                    </label>
                                                    <input
                                                        tabIndex="15"
                                                        type="number"
                                                        value={postalcode}
                                                        onChange={(e) => setPostalcode(e.target.value)}
                                                        className="form-control shadow-none  text-left"
                                                        id="postalcode"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                            <div className='col-12 col-md-6'>
                                                <div
                                                    className="row m-3 rahpardaznet-form-controll">
                                                    <label htmlhtmlFor="address"
                                                           className="text-end form-label px-1 ">
                                                        آدرس محل سکونت
                                                    </label>
                                                    <input
                                                        tabIndex="16"
                                                        type="text"
                                                        value={address}
                                                        onChange={(e) => setAddress(e.target.value)}
                                                        className="form-control shadow-none"
                                                        id="address"
                                                        placeholder=""
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </>
                            </div>
                            <div
                                className='row rahpardaznet-cart  my-5  print-position'>
                                <Header title={'دریافت مدارک'}/>
                                <div className="col-12 col-md-4">
                                    <div
                                        className="form-check rahpdrdaznet-border-bottom">
                                        <input className="form-check-input"
                                               type="checkbox" value=""
                                               checked={rk_birth_certificate ? 'checked' : null}
                                               id="flexCheckIndeterminate"
                                               onChange={(e) => setRk_birth_certificate(e.target.checked)}/>
                                        {
                                            (rk_birth_certificate == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="flexCheckIndeterminate">شناسنامه
                                                    دریافت شده است.</label>
                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="flexCheckIndeterminate">شناسنامه
                                                    دریافت نشده است.</label>
                                            )
                                        }
                                    </div>
                                    <div
                                        className="form-check rahpdrdaznet-border-bottom">
                                        <input className="form-check-input"
                                               type="checkbox" value=""
                                               checked={rk_national_card ? 'checked' : null}
                                               id="rahpardaznet-national-card"
                                               onChange={(e) => setRk_national_card(e.target.checked)}/>
                                        {
                                            (rk_national_card == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-national-card">کارت
                                                    ملی دریافت شده است.</label>
                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-national-card">کارت
                                                    ملی دریافت نشده است.</label>

                                            )
                                        }
                                    </div>
                                    <div
                                        className="form-check rahpdrdaznet-border-bottom">
                                        <input className="form-check-input"
                                               type="checkbox" value=""
                                               id="rahpardaznet-policy"
                                               checked={rk_policy ? 'checked' : null}
                                               onChange={(e) => setRk_policy(e.target.checked)}/>
                                        {
                                            (rk_policy == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-policy">بیمه
                                                    نامه دریافت شده است.</label>
                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-policy">بیمه
                                                    نامه دریافت نشده
                                                    است.</label>

                                            )
                                        }
                                    </div>
                                    <div
                                        className="form-check rahpdrdaznet-border-bottom">
                                        <input className="form-check-input"
                                               type="checkbox" value=""
                                               checked={rk_residence_verification ? 'checked' : null}
                                               id="rahpardaznet-residence-verification"
                                               onChange={(e) => setRk_residence_verification(e.target.checked)}/>
                                        {
                                            (rk_residence_verification == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-residence-verification">احراز
                                                    سکونت دریافت شده
                                                    است.</label>
                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-residence-verification">احراز
                                                    سکونت دریافت نشده
                                                    است.</label>

                                            )
                                        }
                                    </div>
                                    <div
                                        className="form-check rahpdrdaznet-border-bottom">
                                        <input className="form-check-input"
                                               type="checkbox" value=""
                                               id="rahpardaznet-receipt"
                                               checked={rk_receipt ? 'checked' : null}
                                               onChange={(e) => setRk_receipt(e.target.checked)}/>
                                        {
                                            (rk_receipt == true) ? (
                                                <label
                                                    className="form-check-label text-success"
                                                    htmlhtmlFor="rahpardaznet-receipt">فیش
                                                    قبض دریافت نشده است.</label>

                                            ) : (
                                                <label
                                                    className="form-check-label text-danger"
                                                    htmlhtmlFor="rahpardaznet-receipt">فیش
                                                    قبض دریافت شده است.</label>

                                            )
                                        }
                                    </div>
                                </div>
                                <div
                                    className="col-12 col-md-8 rahpdrdaznet-border-right">
                                    <div className="form-group">
                                        <label
                                            htmlhtmlFor="rahpardaznet-description">توضیحات</label>
                                        <textarea className="form-control"
                                                  id="rahpardaznet-description"
                                                  onChange={(e) => setRk_description(e.target.value)}>{rk_description}</textarea>
                                    </div>
                                </div>
                                {
                                    (rk_birth_certificate == true && rk_national_card == true && rk_policy == true && rk_residence_verification == true && rk_receipt == true) ? (
                                        <div className="col-12 pt-3">

                                            <p className='alert alert-success'>تمامی
                                                مدارک دریافت شده اند.</p>
                                        </div>
                                    ) : ''}


                            </div>
                            <div className="row g-2 mb-5">
                                <div className="mx-1 col-6 col-md-12 d-flex justify-content-end me-auto p-0">
                                    {
                                        (!rk_buyer_mobile_validation || btnSubmit) ? (
                                            <button
                                                tabIndex='17'
                                                onClick={documentUpdateHandler}
                                                type="submit"
                                                className="print-no rahpardaznet-btn">
                                                {'ویرایش سند'}

                                            </button>
                                        ) : null
                                    }
                                </div>
                            </div>
                        </>
                    ) : null

                ) : null
            }

        </>
    )
}

export default DocumentEdit;